import angular from 'angular';
import DisableTrackingIdTypingDirective from './disable-tracking-id-typing.directive';

let DisableTrackingIdTypingModule = angular.module('disable-tracking-id-typing-module', [])
    .directive('disableTrackingIdTyping', DisableTrackingIdTypingDirective)
    .name;

export default DisableTrackingIdTypingModule;



// WEBPACK FOOTER //
// ./client/app/common/disable-tracking-id-typing/index.js